import React from 'react';
import type { FormVariant } from '../../types/form';
export function FormIntro({
  variant
}: {
  variant: FormVariant;
}) {
  return <div data-id="element-478" data-mp="3h4msk93cmd3i">
      <p className="text-[14px] font-semibold text-brand" data-id="element-479" data-mp="3h4d2klib05xt">{variant.eyebrow}</p>
      <h1 className="display mt-3 text-[32px] font-semibold text-ink sm:text-[44px] lg:text-[52px]" data-id="element-480" data-mp="3ly7iddusg0rm">
        {variant.headline}
      </h1>
      <p className="mt-5 hidden max-w-[460px] text-[18px] leading-[1.5] text-ink-muted lg:block" data-id="element-481" data-mp="3qxtwdpifxl1h">
        {variant.subheadline}
      </p>
    </div>;
}